.m-item-section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 10000 1 0%;
  min-width: 0;
  min-height: 0;

  &--avatar {
    flex: 0 0 auto;
    min-width: 36px;
    justify-content: center;
    align-items: center;
  }
}
